import { instance } from "../../lib/api";
import constant from "../../utils/CommonConstants";

export const BUILDER_SLOTS_INFO_FAIL = "BUILDER_SLOTS_INFO_FAIL";
export const APPROVAL_REQUEST_IN_PROGRESS = "APPROVAL_REQUEST_IN_PROGRESS";
export const APPROVAL_REQUEST_SUCCESS = "APPROVAL_REQUEST_SUCCESS";
export const APPROVAL_REQUEST_FAIL = "APPROVAL_REQUEST_FAIL";
export const SET_BUILDER_EXCLUSIVITY_LIST = "SET_BUILDER_EXCLUSIVITY_LIST";

export const getBuilderProjectSlotsInfo = (projectId, builderProfileUuid) => {
  return (dispatch) => {
    const baseUrl = `/sapna/api/builder-exclusivity/max-slot-end-date`;
    const queryParams = new URLSearchParams({
      projectId,
      builderProfileUuid,
    }).toString();
    const url = `${baseUrl}?${queryParams}`;

    return instance({
      url,
      method: "get",
    })
      .then((response) => {
        return response?.data?.data;
      })
      .catch((err) => {
        const errorMessage = constant.getErrorMessage(err);
        dispatch({
          type: constant.API_FAIL,
          errMsg: errorMessage,
        });
        const error = new Error();
        error.msg = errorMessage;
        throw error;
      });
  };
};

export const getBuilderExclusivityRequestList = (accountBuilderProfileId) => {
  return (dispatch) => {
    const baseUrl = "/sapna/api/builder-exclusivity/builder-requests";
    const url = `${baseUrl}/${accountBuilderProfileId}`;
    return instance({
      url,
      method: "get",
    })
      .then((response) => {
        dispatch({
          type: SET_BUILDER_EXCLUSIVITY_LIST,
          payload: response?.data?.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: constant.API_FAIL,
          errMsg: constant.getErrorMessage(err),
        });
      });
  };
};
export const postApprovalRequest = ({
  userId,
  accountId,
  accountBuilderProfileId,
  projectId,
  comments,
  stopNpSlots,
  stopListings,
}) => {
  return (dispatch) => {
    const baseUrl = `/sapna/api/builder-exclusivity`;
    const queryParams = new URLSearchParams({
      userId,
      accountId,
      builderProfileUuid: accountBuilderProfileId,
      projectId,
      comments,
      stopNpSlots,
      stopListings,
    }).toString();
    const url = `${baseUrl}?${queryParams}`;

    return instance({
      url,
      method: "post",
    })
      .then(() => {
        dispatch({
          type: constant.API_SUCCESS,
        });
      })
      .catch((err) => {
        dispatch({
          type: constant.API_FAIL,
          errMsg: constant.getErrorMessage(err),
        });
      });
  };
};

export const updateExclusivityRequestEndDate = (projectIds = [], endDate) => {
  return (dispatch) => {
    const normalizedProjectIds = (projectIds || [])
      .map((projectId) => String(projectId).trim())
      .filter(Boolean)
      .join(",");

    const queryParams = new URLSearchParams({
      projectIds: normalizedProjectIds,
      endDate,
    }).toString();
    const url = `/sapna/api/builder-exclusivity/update-exclusivity-request-end-date?${queryParams}`;

    return instance({
      url,
      method: "put",
    })
      .then((response) => {
        dispatch({
          type: constant.API_SUCCESS,
        });
        return response?.data;
      })
      .catch((err) => {
        const errorMessage = constant.getErrorMessage(err);
        dispatch({
          type: constant.API_FAIL,
          errMsg: errorMessage,
        });
        const error = new Error(errorMessage);
        error.msg = errorMessage;
        throw error;
      });
  };
};
